import { IBrand as IFullBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IProduct as IFullProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { IProductOption as IFullIProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";

export const transformProductToOptionLessProduct = (
  product: IFullProduct
): ILeanProductTile.ILeanProduct =>
  ILeanProductTile.ILeanProduct.build({
    token: product.token,
    brand_token: product.brand_token,
    name: product.name,
    is_new: product.is_new,
    board_tokens: product.board_tokens,
    expected_ship_date: product.expected_ship_date,
    expected_ship_window_days: product.expected_ship_window_days,
    is_high_sell_through: product.is_high_sell_through,
    maker_best_seller: product.maker_best_seller,
    per_style_min_order_quantity: product.per_style_min_order_quantity,
    state: product.state,
  });

export namespace transformProductToOptionLessProduct {
  export interface IProduct
    extends Pick<
      IFullProduct,
      | "token"
      | "brand_token"
      | "name"
      | "description"
      | "is_new"
      | "board_tokens"
      | "expected_ship_date"
      | "expected_ship_window_days"
      | "is_high_sell_through"
      | "maker_best_seller"
      | "per_style_min_order_quantity"
      | "images"
      | "customizations"
      | "min_order_quantity"
      | "allow_sales_when_out_of_stock"
      | "max_option_retail_price"
      | "max_option_wholesale_price"
      | "state"
      | "has_pre_packs_available"
      | "is_highlighted_product_for_promotional_event"
      | "unit_multiplier"
      | "taxonomy_type"
    > {
    options: IProductOption[];
  }
  export type IProductOption = Pick<
    IFullIProductOption,
    | "token"
    | "images"
    | "unit_count_per_cart_item"
    | "retail_price"
    | "unit_multiplier"
    | "wholesale_price"
    | "available_units"
    | "wholesale_price_cents"
    | "retail_price_cents"
    | "wholesale_promo_price"
  >;
}

export const transformBrandToLeanBrand = (
  brand: IFullBrand
): ILeanProductTile.IBrand =>
  ILeanProductTile.IBrand.build({
    token: brand.token,
    name: brand.name,
    minimum_order_amount: brand.minimum_order_amount,
    free_shipping_reason: brand.free_shipping_reason,
    forbids_online_only_retailers: brand.forbids_online_only_retailers,
    ships_from_country: brand.ships_from_country,
    is_highlighted_brand_for_promotional_event:
      brand.is_highlighted_brand_for_promotional_event,
    based_in: brand.based_in,
  });

export namespace transformBrandToLeanBrand {
  export type IBrand = Pick<
    IFullBrand,
    | "token"
    | "name"
    | "minimum_order_amount"
    | "free_shipping_reason"
    | "forbids_online_only_retailers"
    | "ships_from_country"
    | "is_highlighted_brand_for_promotional_event"
    | "based_in"
  >;
}
